import React, { useEffect, useState } from 'react';
import api from '../services/api';
import './SharkList.css';

const SharkList = () => {
    const [sharks, setSharks] = useState([]);
    const [filteredSharks, setFilteredSharks] = useState([]);
    const [filter, setFilter] = useState('');
    const [round, setRound] = useState(1);

    useEffect(() => {
        const fetchSharks = async () => {
            try {
                const response = await api.get(`/sharks/?round=${round}`);
                setSharks(response.data);
                setFilteredSharks(response.data);
            } catch (error) {
                console.error('Error fetching sharks:', error);
            }
        };

        fetchSharks();
    }, [round]);

    useEffect(() => {
        if (filter === '') {
            setFilteredSharks(sharks);
        } else {
            const lowercasedFilter = filter.toLowerCase();
            const filteredData = sharks.filter(item => {
                return Object.keys(item).some(key =>
                    item[key].toString().toLowerCase().includes(lowercasedFilter)
                );
            });
            setFilteredSharks(filteredData);
        }
    }, [filter, sharks]);

    return (
        <div className="shark-list-container">
            <h2>Shark List</h2>
            <div className="filter-container">
                <input
                    type="text"
                    placeholder="Filter by any value..."
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                />
                <select value={round} onChange={(e) => setRound(e.target.value)}>
                    <option value="1">Round 1</option>
                    <option value="2">Round 2</option>
                    <option value="3">Round 3</option>
                </select>
            </div>
            <table className="shark-table">
                <thead>
                    <tr>
                        <th>Shark ID</th>
                        <th>Weight (lbs)</th>
                        <th>Weight (oz)</th>
                        <th>Round</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredSharks.map((shark) => (
                        <tr key={shark.id}>
                            <td>{shark.shark_id}</td>
                            <td>{shark.weight_lbs}</td>
                            <td>{shark.weight_oz}</td>
                            <td>{shark.round}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default SharkList;